/* eslint-disable */
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  plugins: [
    createPersistedState(),
  ],
  state: {
    user: null,
    password: null,
    rememberMe: false,
    isAdmin: false,
  },
  getters: {
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setPassword(state, password) {
      state.password = password
    },
    setRememberMe(state, value) {
      state.rememberMe = value
    },
    setIsAdmin(state, value) {
      state.isAdmin = value
    },
  },
  actions: {
    login({ commit }, { credentials, rememberMe }) {
      // Perform login request here
      // ...

      if (rememberMe) {
        commit('setUser', user)
        commit('setPassword', password)
        commit('setRememberMe', true)
      }
    },
    logout({ commit }) {
      commit('setUser', null)
      commit('setPassword', null)
      commit('setRememberMe', false)
      commit('setIsAdmin', false)
    }
  },
  modules: {
  }
})
